import { ChangeDetectionStrategy, Component, Input, ViewChild, ViewEncapsulation } from '@angular/core';
import { LicenseConnectorsSettingsComponent } from '@portal-core/licenses/components/license-connectors/license-connectors-settings/license-connectors-settings.component';
import { Connector } from '@portal-core/publications/models/connector.model';

@Component({
  selector: 'mc-license-connectors',
  templateUrl: './license-connectors.component.html',
  styleUrls: ['./license-connectors.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush
})

export class LicenseConnectorsComponent {
  @Input() licenseId: number;
  @Input() licenseUserId: number;

  @ViewChild('licenseConnectorsSettings', { static: false }) licenseConnectorsSettingsComponent: LicenseConnectorsSettingsComponent;

  showConnectorSettings: boolean = false;
  selectedConnector: Connector;

  onConnectorSelected(connector: Connector = null) {
    this.selectedConnector = connector;
    this.showConnectorSettings = true;
  }

  onSuccess() {
    this.showConnectorSettings = false;
  }

  onCancel() {
    this.showConnectorSettings = false;
  }
}
